import { getCronLogoSrc } from "./cronCatalog";

const CronLogo = ({ type, size = "md", src, title }) => {
    const large = size === "lg";
    return (
        <span title={title} className={`grid flex-none place-items-center overflow-hidden border border-[#ececef] bg-white ${large ? "h-9 w-9 rounded-[9px]" : "h-7 w-7 rounded-[7px]"}`}>
            <img alt="" src={src ?? getCronLogoSrc(type)} className={`object-contain ${large ? "h-6 w-6" : "h-[18px] w-[18px]"}`} />
        </span>
    );
};

export default CronLogo;
